import { render, staticRenderFns } from "./AddUpdateLearningGoal.vue?vue&type=template&id=0210c9f2&"
import script from "./AddUpdateLearningGoal.vue?vue&type=script&lang=js&"
export * from "./AddUpdateLearningGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports